export const BASE_URL = "https://smartnotes-1.onrender.com";
